import { render } from "./Stocks.vue?vue&type=template&id=57738d22&scoped=true"
import script from "./Stocks.vue?vue&type=script&lang=js"
export * from "./Stocks.vue?vue&type=script&lang=js"

import "./Stocks.vue?vue&type=style&index=0&id=57738d22&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\framacion_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57738d22"]])

export default __exports__